<template>
    <a  :href="whatsappLink" target="_blank" class="float-wrap ">
        <div class="btn-float">
            <img src="@/assets/evermore_beauty_store/redes_sociales/WhatsApp_icon.png" alt="WA" />
        </div>
    </a>

</template>

<script setup>
    const telefono = "522283616313"
    const mensaje = "Hola Evermore Beauty, quisiera solicitar información ✿ "
    const whatsappLink = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`


const wrap = document.querySelector('.float-wrap');

if (window.innerWidth > 768) {
  document.addEventListener('mousemove', (e) => {
    const rect = wrap.getBoundingClientRect();

    const x = e.clientX - (rect.left + rect.width / 2);
    const y = e.clientY - (rect.top + rect.height / 2);

    const distance = Math.sqrt(x * x + y * y);

    if (distance < 120) {
      wrap.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
    } else {
      wrap.style.transform = `translate(0,0)`;
    }
  });
}
</script>

<style>
.float-wrap {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;

  width: 70px;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-float {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(191, 192, 243, 0.339);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow:
    0 8px 25px rgba(0,0,0,0.15),
    0 0 15px rgba(37, 75, 211, 0.239);
  transition: transform 0.2s ease;
}

/* ICONO */
.btn-float img {
  width: 70%;
  height: 70%;
}

/* ✨ entrada animada */
.float-wrap {
  opacity: 0;
  transform: translateY(40px) scale(0.8);
  animation: floatIn 0.8s ease forwards;
  animation-delay: 0.5s;
}

@keyframes floatIn {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ✨ burbuja flotante suave */
@keyframes floaty {
  0% { transform: translateY(0px); }
  100% { transform: translateY(-6px); }
}

.btn-float {
  animation: floaty 2s infinite alternate ease-in-out;
}


</style>